import React from "react";
import { Col, Row } from "react-bootstrap";
import Button from "pages/_components/Button";
import I18n from "pages/_components/I18n";
import { func, string } from "prop-types";

const SideBarCedipForm = ({ idAccion, handleCancel, handleAccept }) => (
    <div className="container above-the-fold">
        <Row />
        <Row />
        <Row />
        <Row>
            <Col xs={12} md={8} mdOffset={2}>
                <I18n id={`cedip.${idAccion}.title.1`} component="h2" />
            </Col>
        </Row>
        <Row className="justify-content-md-center">
            <Col xs={12} md={8} mdOffset={2}>
                <I18n id={`cedip.${idAccion}.title.2`} component="span" />
            </Col>
        </Row>
        <Row className="justify-content-md-center">
            <Col xs={12} md={8} mdOffset={2}>
                <Button className="btn-primary" label={`cedip.${idAccion}.button.accept`} onClick={handleAccept} />
            </Col>
        </Row>
        <Row className="justify-content-md-center">
            <Col xs={12} md={8} mdOffset={2}>
                <Button className="btn-outline" label="global.cancel" onClick={handleCancel} />
            </Col>
        </Row>
    </div>
);

SideBarCedipForm.propTypes = {
    idAccion: string.isRequired,
    handleAccept: func.isRequired,
    handleCancel: func.isRequired,
};

export default SideBarCedipForm;
